import aws from "aws-sdk";

import awsGlobal from "aws-sdk/global";
import config from "@/aws-cognito/config.js";
// import util from "util";

aws.config.update({
  region: config.poolData.region,
});

aws.config.credentials = new aws.CognitoIdentityCredentials({
  IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
});

const AWS = aws;

const AWSGlobal = awsGlobal;

const Cognito = new AWS.CognitoIdentityServiceProvider();

export { AWS, AWSGlobal, Cognito };
